/* eslint-disable no-nested-ternary */
import { purify } from '@vfit/shared/themes';
import { IBasicCard } from './basicCard.modules';

export const organizeBasicCard = (data: IBasicCard) => ({
  purifiedData: {
    title: {
      text: purify([data?.title?.text || ''])?.[0],
      fontSize: data?.title?.fontSize,
      color: data?.title?.color,
    },
    texts: data?.texts?.map((t) => ({
      text: purify([t?.text || ''])?.[0],
      fontSize: data?.title?.fontSize,
      color: data?.title?.color,
    })),
  },
});
